<div class="grid grid-cols-12 gap-2 relative">
  @if (isMultiple || (!files?.length)){
    <div
      class="col-span-12 {{files?.length > 0 ? 'md:col-span-3' : ''}} container bg-primary/5 !text-primary border-dashed border !border-primary rounded-2xl p-3 !pt-1 text-center flex flex-col justify-between items-center gap-1"
      appDragDrop (fileDropped)="onFileDropped($event)">
      <div *ngIf="loading" class="absolute -top-3 left-0 right-0">
        <app-loader [showMessage]="false"></app-loader>
      </div>
      <input type="file" #fileDropRef (change)="fileBrowseHandler($event)" [accept]="acceptableFileTypes"/>
      <img src="assets/images/upload.svg" alt="file" class="w-12 inline-block">
      <h3>{{ attachmentTitle }} &nbsp;&nbsp; [<span class="!text-xs">{{ 'Acceptable' | concat | translate }}: <span
        class="text-red-500">{{ acceptableFileTypes }}</span></span>]</h3>
      <h3>{{ 'or' | concat | translate }}</h3>
      <label (click)="fileDropRef.click()"
             class="bg-white text-primary border-solid border border-primary rounded-lg cursor-pointer px-4 py-2">
        {{ 'Browse for file' | concat | translate }}</label>
    </div>
  }

  <ng-container *ngIf="files?.length > 0">
    <div class="col-span-12 {{ isMultiple ? 'md:col-span-9' : '' }} files-list">
      <div class="">
        <div class="single-file" *ngFor="let file of files; let i = index">
          <!--<img src="assets/img/dnd/ic-file.svg" width="45px" alt="file">-->
          <div class="info">
            <h4 class="name">
              {{ file?.name }}
            </h4>
            <p class="size">
              {{ formatBytes(file?.size) }}
            </p>
            <!--<app-progress [progress]="file?.progress"></app-progress>-->
          </div>
          <div
            class="p-2 bg-primary/10 hover:bg-primary/15 transition rounded text-primary cursor-pointer inline-grid place-items-center"
            (click)="openAttachment(filesToSave[i], i)">
            <mat-icon *ngIf="!isLoading[i]">visibility</mat-icon>
            <mat-progress-spinner *ngIf="isLoading[i]" [diameter]="25" color="primary" mode="indeterminate"></mat-progress-spinner>
          </div>
          <div
            class="delete p-2 bg-red-500/10 hover:bg-red-500/15 transition rounded text-red-500 cursor-pointer inline-grid place-items-center"
            (click)="deleteFile(i)">
            <mat-icon>delete</mat-icon>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
